<template>
    <div>
        <div class="flex flex-col items-center justify-center h-full gap-3">
            <icon icon-name="no-leave" style="width: 106px; height: 108px;" class="text-darkPurple" />
            <h2 class="text-xl font-bold text-flame">{{ title }}</h2>
            <p class="text-center text-base text-jet px-6">
                {{ description }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NoLeave",
        props: {
            title: {
                type: String,
                default: "No Leaves Available"
            },
            description: {
                type: String,
                default: "It looks like there are no leaves available"
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>